import { Link, useLocation, useParams } from "react-router-dom";
import Dasboard from "../../../../Components/Icons/Dasboard";
import {
  MainHeading,
  NormalHeading,
  SecondHeading,
} from "../../../../Components/Utils/Heading";
import { BackButton, EditButton } from "../../../../Components/Utils/Buttons";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { GetRole } from "../../../../Components/Utils/roles";
import ViewIcon from "../../../../Components/Icons/ViewIcon";
import { useEffect, useState } from "react";
import axiosInstance from "../../../../Services/axiosCommon";
import NuDate from "../../../../Components/Utils/NuDate";

const SubConView = ({ openModel, closeModel }) => {
  const { subConViewId,officeId} = useParams();
    const location = useLocation();
   
    const pageIndex = location.state?.pageIndex;
    const searchQuery = location.state?.searchQuery;
    
  const stateData = location?.state?.data;
  const [store,setStore]=useState(stateData? stateData:null)
  const initialProducts = stateData?.products ? stateData.products.split(", ").map((p) => p.trim()) : [];
  const [productList, setProductList] = useState(initialProducts);
  const initialEmails = stateData?.emails ? stateData.emails.split(", ").map((p) => p.trim()) : [];
  const [emailsList, setEmailsList] = useState(initialEmails);
  const initialServices = stateData?.services ? stateData.services.split(", ").map((p) => p.trim()) : [];
  const [servicesList, setServicesList] = useState(initialServices);
  const [showValidation, setShowValidation] = useState(false);

  const [data,setData] = useState(stateData? stateData:null); 
 
  

  function getViewnew() {
    axiosInstance
      .get(`/vendors/${subConViewId}`)
      .then((res) => {
        let response = res.data?.data;
        setData(response);     
        setStore(response);  
        setProductList(response?.products ? response.products.split(", ").map((p) => p.trim()) : []);     
        setEmailsList(response?.emails ? response.emails.split(", ").map((p) => p.trim()) : []);     
        setServicesList(response?.services ? response.services.split(", ").map((p) => p.trim()) : []);     

      })
      .catch((error) => {
        console.log(error);
      });
  }
  
  useEffect(() => {
    if (!stateData) {
      getViewnew();
    }
  }, [subConViewId]);




  const [showConfirm, setShowConfirm] = useState(false);

  const handleApproveClick = () => {
    setShowConfirm(true);
  };



  const [isPopupOpenAccess, setIsPopupOpenAccess] = useState(false);

  const togglePopupAccess = () => {
    setIsPopupOpenAccess(!isPopupOpenAccess);
  };

return (
  <div className="w-full h-full py-2 px-4 ">
    <div className="flex justify-end ">
      {/* <Breadcrumb
        items={[
          {
            name: "sub-con",
            link: "/procurement/sub-con",
          },
          {
            name: "View sub-con",
          },
        ]}
      /> */}
      <div className=" flex gap-2">
      
 

        <Link to={`/main/${officeId}/contacts/sub-con`} state={{currentPage:pageIndex,searchQuery:searchQuery!=""?searchQuery:""}}>
          <BackButton link={true} />
        </Link>
        <Link
          to={`/main/${officeId}/contacts/sub-con/edit/${subConViewId}`}
          state={{
            data: data,
            from: `/main/${officeId}/contacts/sub-con/view/${subConViewId}`,
          }}
        >
          <EditButton height="8" />
        </Link>
      </div>
    </div>
    <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-md mt-4 overflow-y-scroll p-3">
 {/* <div className='flex justify-between'>

      <NormalHeading title={data?.conName} />

      </div> */}
      <div className="flex">
        <div className="w-full  flex  ">
          <div className="w-full rounded-[20px]  bg-white   flex  flex-col  ">
          <div className="w-full">
                <p className="py-2 px-2 text-xs 2xl:text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                Company Details :
                </p>
              </div>
              
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Company Name
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.companyName}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Category
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.category}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Phone
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.phoneWithCC}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Email
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]  break-words">{data?.email}</p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Website
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.website}
              </p>
            </div>
          
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                TaxId
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">{data?.taxId}</p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Performance Ratings
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.performanceRating}
              </p>
            </div>
           
          <div className="w-full">
                <p className="py-2 px-2 text-xs 2xl:text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                Sub-Contractor Details :
                </p>
              </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Title
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.title}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Con Name
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.conName}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Sub-Con Number
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.subConNumber}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Sub-Con Type
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.subConType}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Signed On
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.signedOn? (
                  <NuDate value={data?.signedOn} format="DD-MMM-YYYY" />
                ) : (
                  "N/A"
                )}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Con-Value
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.conValue}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Con-Period
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.conPeriod? (
                  <NuDate value={data?.conPeriod} format="DD-MMM-YYYY" />
                ) : (
                  "N/A"
                )}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Start Date
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.startDate}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                End Date
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.endDate}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Renewed On
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.renewedOn? (
                  <NuDate value={data?.renewedOn} format="DD-MMM-YYYY" />
                ) : (
                  "N/A"
                )}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Renewable
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.renewable == true? 'Yes': 'No'}
              </p>
            </div>
            
           
           
          </div>
        </div>
        <div className="border-r border-[1px] border-slate-200/60 border-solid" />

        <div className="w-full  flex gap-3 ">
          <div className="w-full rounded-[20px]  bg-white   flex  flex-col  ">
          <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Valid Upto
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.validUpto? (
                  <NuDate value={data?.validUpto} format="DD-MMM-YYYY" />
                ) : (
                  "N/A"
                )}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Termination Date
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.terminationDate? (
                                  <NuDate value={data?.terminationDate} format="DD-MMM-YYYY" />
                                ) : (
                                  "N/A"
                                )}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Amendmend Reference
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.amendmendRef}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Amendmend Value
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.amendmendValue}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Total-Con Value
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.totalConValue}
              </p>
            </div>
          <div className="w-full">
                <p className="py-2 px-2 text-xs 2xl:text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                  Contact Person Details :
                </p>
              </div>
              
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Contact Person{" "}
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.contactPerson}
              </p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Designation
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.designation}
              </p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Contact Person Email
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.contactPersonEmail}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Contact Person Mobile
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.cPMobileWithCC}
              </p>
            </div>
            
            {/* <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Comments
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.comments}
              </p>
            </div> */}
          <div className="w-full">
                <p className="py-2 px-2 text-xs 2xl:text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                Address :
                </p>
              </div>
              
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Street Address Line 1
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.address1 || ""}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Street Address Line 1
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.address2 || ""}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                City
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">{data?.city}</p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                State / Province
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">{data?.state}</p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Postal / Zip Code
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.postalCode}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Country
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.country}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Scope of Work
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.scopeOfWork}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2">
              <p className="w-1/2 py-2 text-xs font-medium text-[#111537]">
                Comments
              </p>
              <p className="w-1/2 py-2 text-xs  text-[#606279]">
                {data?.comments}
              </p>
            </div>
          </div>
        </div>
      </div>
     
    </div>
   
  

  </div>
);
};
export default SubConView;

function SubComponent({ label, value }) {
  return (
    <div className={` my-3 px-2`}>
      <div className=" w-full mx-auto">
        {/* <TextBold text={value} /> */}
        <h3 className="text-mainColor-400  line-clamp-2 font-semibold text-xs">
          {label || "-"}
        </h3>
        <h3 className="text-[#9A95A8] capitalize font-medium text-xs">
          {value || "-"}
        </h3>
        {/* <SmallHeading title={label} /> */}
      </div>
    </div>
  );
}
